import { areas, Area } from "@App/utils/areas";

export const useRegion = () => {
  // postcode is between from and till
  const getRegionAbbreviation = (postcode: string) => {
    return (
      areas.find((area: Area) => {
        return postcode >= area.from && postcode <= area.till;
      })?.region || "BUND"
    );
  };

  return {
    getRegionAbbreviation,
  };
};
